module.exports = __webpack_public_path__ + "img/pokataev.1ea5cb23.jpg";